import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiTranslateModule } from '@fcom/ui-translate';

import { IconsModule } from '../icons/icons.module';
import { SideBarComponent } from './sidebar.component';
import { ClickOutsideDirectiveModule } from '../../directives/click-outside/click-outside-directive.module';
import { TrapFocusModule } from '../../directives/trap-focus/trap-focus.module';

@NgModule({
  declarations: [SideBarComponent],
  imports: [CommonModule, IconsModule, UiTranslateModule, ClickOutsideDirectiveModule, TrapFocusModule],
  exports: [SideBarComponent],
})
export class SideBarModule {}
